export const RECRUITING_VIDEOS_ENDPOINT = '/v1/cpp/recruiting-videos';
export const RECRUITING_VIDEOS_ORDER_ENDPOINT = '/v1/cpp/recruiting-videos/order';
export const MAX_VIDEOS = 4;
export const TITLE_MAX_LENGTH = 50;
export const DESCRIPTION_MAX_LENGTH = 150;
export const URL_PLACEHOLDER = 'Paste a YouTube, Vimeo, or Hudl link';
// Exact-match allowlist. Explicit subdomains only — no wildcard/endsWith
// matching, so a typo like `ww.youtube.com` or a lookalike like
// `evil.youtube.com` is rejected. Add a real subdomain here when needed.
export const ALLOWED_VIDEO_HOSTS = [
    'youtube.com',
    'www.youtube.com',
    'm.youtube.com',
    'youtu.be',
    'vimeo.com',
    'www.vimeo.com',
    'player.vimeo.com',
    'hudl.com',
    'www.hudl.com',
];
